import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const INITIAL_STATE = {
  isFlowActive: false,
  currentStep: 1,
  step1Draft: {
    selectedBankId: null,
    selectedBankName: null,
    selectedBankCode: null,
    accountNumber: "",
    // FUTURE RELEASE: MSISDN field in step1 draft — re-enable when phone number bank verification is supported
    // msisdn: "",
    verificationMethod: "account_number",
  },
  verifiedData: {
    accountName: null,
    bankName: null,
    accountNumber: null,
    swiftCode: null,
    branchCode: null,
    statusCode: null,
  },
};

const useBankAccountStore = create(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      startFlow: () => set({ isFlowActive: true }),
      setStep: (currentStep) => set({ currentStep }),
      setStep1Draft: (step1Draft) => set({ step1Draft }),
      setVerifiedData: (verifiedData) => set({ verifiedData }),
      resetFlow: () => set(INITIAL_STATE),
    }),
    {
      name: "bank-account-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isFlowActive: state.isFlowActive,
        currentStep: state.currentStep,
        step1Draft: {
          selectedBankId: state.step1Draft.selectedBankId,
          selectedBankName: state.step1Draft.selectedBankName,
          selectedBankCode: state.step1Draft.selectedBankCode,
          accountNumber: state.step1Draft.accountNumber,
          // FUTURE RELEASE: Persist MSISDN in sessionStorage — re-enable with phone verification
          // msisdn: state.step1Draft.msisdn,
          verificationMethod: state.step1Draft.verificationMethod,
        },
        verifiedData: {
          accountName: state.verifiedData.accountName,
          bankName: state.verifiedData.bankName,
          accountNumber: state.verifiedData.accountNumber,
          swiftCode: state.verifiedData.swiftCode,
          branchCode: state.verifiedData.branchCode,
          statusCode: state.verifiedData.statusCode,
        },
      }),
    },
  ),
);

export default useBankAccountStore;
